const Spinner = () => `
  <div class="spinner-wrapper">
    <span class="spinner-grow merah" role="status"></span>
    <span class="spinner-grow putih" role="status"></span>
    <span class="spinner-grow merah" role="status"></span>
  </div>
`;

export default Spinner;
